import styled, { css } from 'styled-components'

export const MenuOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.colors.border.default} transparent;

  nav {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp8};
  }

  p {
    opacity: 0 !important;
  }

  ul {
    ${props =>
      props.showMenu &&
      css`
        width: 232px;

        p {
          opacity: 1 !important;
        }
      `}
  }
`

export const List = styled.ul`
  width: ${props => props.theme.size.XL};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  list-style: none;
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
  transition: width 0.25s ease-in-out;
  background-color: ${props => props.color || props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const CustomDivider = styled.div`
  width: calc(100% + 24px);
  height: 1px;
  background-color: #d2d2d2;
  margin-left: -12px;
`

export const MerchantSection = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
`
